import React, { Component } from 'react';
import { Form, Modal, Input, Radio, message, Badge } from 'antd';
import { app } from "../../app";
import ReTeamCode from "./ReTeamCode";
import ReTeamGrant from "./ReTeamGrant";
import api from "../../api";

class ReTeam extends Component {

    constructor (props) {
        super(props);
        this.state = {
            review_visible: false,
            reviewInfo: {},
            auditCount: {},
            sel_tab: "1",
            tabs: [
                { val: "1", name: "荣誉编号审核", count: "team_code_audit_count" },
            ],
        };
    }

    componentDidMount () {
        this._isMounted = true;
        this.dataCountSource();
        
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataCountSource = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, data, msg } = await app.post(api.TeamAuditCount, params);
        if (flag === 1) {
            let { tabs } = this.state, rights = app.getData("rights");
            if (data.authorize_audit || ("1".indexOf(rights) > -1)) {
                tabs.push({ val: "2", name: "注册信息审核", count: "authorize_audit_count" });
                this.setData({ tabs });
            }
            this.setData({ auditCount: data });
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 审核结果
     * @param audit
     * @param detail
     * @param reviewInfo
     * @param other_params
     * @returns {Promise<boolean>}
     */
    handleCheckReview = async (audit, detail, reviewInfo, other_params) => {
        app.alert('正在审核~', 'loading', '35%', 0);
        const { uri, id, id_key, source } = reviewInfo || this.state.reviewInfo;
        let params = {
            audit,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        params[id_key] = id; //id
        if (audit === 2) params.detail = detail;
        if (other_params && other_params instanceof Object) params = Object.assign(params, other_params);
        let { flag, msg } = await app.post(uri, params);
        message.destroy();
        if (audit === 2) this.CloseReviewModal();
        if (flag === 1) {
            app.alert('审核成功', 'success');
            if (source) source();
            return true;
        } else {
            app.alert(msg, 'warn');
            return false;
        }
    }

    /**
     * 提交意见
     * @param e
     */
    handleSubmitIdea = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                await this.handleCheckReview(2, values.detail);
            }
        })
    }

    /**
     * 打开不通过审核对话框
     */
    OpenReviewModal = (reviewInfo) => {
        this.setData({ review_visible: true, reviewInfo });
    }

    /**
     * 关闭不通过审核对话框
     * @constructor
     */
    CloseReviewModal = () => {
        this.setData({ review_visible: false, reviewInfo: {} });
        this.props.form.resetFields();
    }

    /**
     * 审核结果
     * @param rule
     * @param value
     * @param callback
     */
    handleReviewResult = (rule, value, callback) => {
        if (value && value.trim() === '') {
            callback('请输入审核失败原因！')
        }
        callback()
    }

    /**
     * Tab按钮变换
     * @param e
     */
    handleTabBtnChange = (e) => {
        let { value } = e.target;
        this.setData({ sel_tab: value });
    }

    render () {
        let { review_visible, sel_tab, tabs, auditCount } = this.state,
            { getFieldDecorator } = this.props.form,
            zi_props = {
                successReview: this.handleCheckReview,
                failReview: this.OpenReviewModal,
            };
        let content_node = null;
        switch (sel_tab) {
            case "1":   //荣誉编码审核
                content_node = (<ReTeamCode {...zi_props}/>);
                break;
            case "2":   //注册信息审核
                content_node = (<ReTeamGrant {...zi_props}/>);
                break;
        }
        return (
            <div className="review-info">
                <div className="page-title">队伍信息审核</div>
                <div className="page-content">
                    <div className="review-info-tab">
                        <Radio.Group value={sel_tab} buttonStyle="solid" onChange={this.handleTabBtnChange}>
                            {
                                tabs.map((tab, index) =>
                                    <Badge count={auditCount[tab.count] || 0} key={index}>
                                        <Radio.Button key={index} value={tab.val}
                                                      className='no-select'>{tab.name}</Radio.Button>
                                    </Badge>
                                )
                            }
                        </Radio.Group>
                    </div>
                    <div className="review-info-content">
                        {content_node}
                    </div>
                    <Modal
                        visible={review_visible}
                        onOk={this.handleSubmitIdea}
                        onCancel={this.CloseReviewModal}
                        okText="确定"
                        cancelText="取消"
                        title="审核不通过原因"
                        maskClosable={false}
                        keyboard={false}
                        style={{ top: '30%' }}
                    >
                        <Form>
                            {getFieldDecorator('audit', { initialValue: 2 })(
                                <Input type="hidden"/>
                            )}
                            <Form.Item
                                label="失败原因"
                                labelCol={{ span: 4 }}
                                wrapperCol={{ span: 19, offset: 1 }}
                            >
                                {getFieldDecorator('detail', {
                                    rules: [
                                        { required: true, message: '请输入审核失败原因!' },
                                        { validator: this.handleReviewResult }
                                    ],
                                })(
                                    <Input.TextArea autosize={{ minRows: 4, maxRows: 10 }}/>
                                )}
                            </Form.Item>
                        </Form>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Form.create()(ReTeam);



// WEBPACK FOOTER //
// ./src/routes/review/ReTeam.jsx